// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1qPKb","title":"ClientInsurance_title__2Oz_Z","itemText":"ClientInsurance_itemText__-IDiD"};